import React from 'react'
import './capsule.scss'
import { InfoTooltip } from '../../atoms/info-tooltip/info-tooltip'

interface CapsuleProps {
  isTooltip?: boolean
  title: string
  subInfo: string
  toolTipInfo?: string
  onCapsuleClicked: (id: number) => void
  selectedCapsuleId: number
  id: number
}

export const Capsule = ({
  isTooltip = false,
  title,
  subInfo,
  toolTipInfo,
  onCapsuleClicked,
  selectedCapsuleId,
  id,
}: CapsuleProps) => {
  return (
    <div
      className={`capsule-container ${selectedCapsuleId === id ? 'selected-capsule' : ''}`}
      onClick={() => onCapsuleClicked(id)}
    >
      <div className="capsule-card">
        <div className="capsule-info">
          <p className="capsule-text">{title}</p>
          {isTooltip && <InfoTooltip tooltipContent={toolTipInfo} />}
        </div>
        <p className="capsule-subInfo">{subInfo}</p>
      </div>
    </div>
  )
}
